import { __assign, __awaiter, __generator } from "tslib";
import { PluginType } from '@amplitude/analytics-types';
import { PluginCampaignTracker } from './plugin-campaign-tracker';
export var webAttributionPlugin = function webAttributionPlugin(client, options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'web-attribution',
    type: PluginType.BEFORE,
    setup: function setup(config) {
      return __awaiter(void 0, void 0, void 0, function () {
        var storage, campaignTracker;

        var _a;

        return __generator(this, function (_b) {
          config.loggerProvider.log('Installing @amplitude/plugin-web-attribution-browser'); // Disable "runAttributionStrategy" function

          if (!((_a = config.attribution) === null || _a === void 0 ? void 0 : _a.disabled)) {
            config.loggerProvider.warn('@amplitude/plugin-web-attribution-browser overrides web attribution behavior defined in @amplitude/analytics-browser');
            config.attribution = {
              disabled: true
            };
          }

          storage = config.cookieStorage;
          campaignTracker = new PluginCampaignTracker(config.apiKey, storage, __assign({}, options)); // Web Attribution tracking

          void campaignTracker.onPageChange(function (_a) {
            var isNewCampaign = _a.isNewCampaign,
                currentCampaign = _a.currentCampaign;
            return __awaiter(void 0, void 0, void 0, function () {
              return __generator(this, function (_b) {
                if (isNewCampaign) {
                  if (options.resetSessionOnNewCampaign) {
                    client.setSessionId(Date.now());
                    config.loggerProvider.log('Created a new session for new campaign');
                  }

                  config.loggerProvider.log('Tracking new campaign event');
                  void client.track(campaignTracker.createCampaignEvent(currentCampaign));
                }

                return [2
                /*return*/
                ];
              });
            });
          });
          return [2
          /*return*/
          ];
        });
      });
    },
    execute: function execute(event) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2
          /*return*/
          , event];
        });
      });
    }
  };
};